import type { QueryClient } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

function useOnline() {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

function UpdateBanner() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div className="banner" role="status">
      <span>A new version is ready.</span>
      <button type="button" onClick={() => void updateServiceWorker(true)}>
        Update
      </button>
    </div>
  );
}

function Root() {
  const online = useOnline();
  return (
    <div className="shell">
      <header className="topbar">
        <span className="brand">p14nner</span>
        {!online && <span className="pill">offline</span>}
      </header>
      <UpdateBanner />
      <main className="page">
        <Outlet />
      </main>
    </div>
  );
}

export const Route = createRootRouteWithContext<{ queryClient: QueryClient }>()({
  component: Root,
});
